import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Intro.css";
import logo from "../../assets/logolanding.png";
import { API_BASE } from "../../api";



export default function Intro() {
  const navigate = useNavigate();
  const { sessionId, role } = useParams();
  const [loading, setLoading] = useState(false);

  const completed = JSON.parse(
    localStorage.getItem(`completedClasses_${sessionId}`) || "[]"
  );

  async function startClass(phase) {
    if (loading) return;
    if (role !== "A") return;

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/module2/select-phase`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          role,
          phase
        })
      });

      const data = await res.json();

      if (data.status === "confirmed") {
        navigate(`/module2/phase-intro/${sessionId}/A/${data.phase}`);
      }

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (role !== "B") return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_BASE}/module2/select-phase-status/${sessionId}`
        );

        const data = await res.json();

        const completed = JSON.parse(
          localStorage.getItem(`completedClasses_${sessionId}`) || "[]"
        );

        if (
          data.phase &&
          !completed.includes(Number(data.phase)) &&
          window.location.pathname === `/module2/${sessionId}/${role}`
        ) {
          clearInterval(interval);

          navigate(`/module2/phase-intro/${sessionId}/B/${data.phase}`);
        }

      } catch {}

    }, 1500);

    return () => clearInterval(interval);

  }, [role, sessionId, navigate]);

  return (
    <div className="intro-hero">

      <div className="intro-bubbles">
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="intro-bubble"
            style={{
              left: Math.random() * 100 + "%",
              animationDelay: Math.random() * 6 + "s",
              animationDuration: 6 + Math.random() * 6 + "s"
            }}
          />
        ))}
      </div>

      <div className="intro-wheel">

        <img src={logo} alt="ReflectUS" className="intro-logo" />

        <button
          className={`intro-node top ${completed.includes(1) ? "node-locked" : ""}`}
          disabled={role !== "A" || completed.includes(1)}
          onClick={() => startClass(1)}
        >
          ◦ Presence
        </button>

        <button
          className={`intro-node right ${completed.includes(2) ? "node-locked" : ""}`}
          disabled={role !== "A" || completed.includes(2)}
          onClick={() => startClass(2)}
        >
          ◇ Emotions
        </button>

        <button
          className={`intro-node bottom-right ${completed.includes(4) ? "node-locked" : ""}`}
          disabled={role !== "A" || completed.includes(4)}
          onClick={() => startClass(4)}
        >
          ✦ Intimacy 
        </button>

        <button
          className={`intro-node bottom-left ${completed.includes(3) ? "node-locked" : ""}`}
          disabled={role !== "A" || completed.includes(3)}
          onClick={() => startClass(3)}
        >
          △ Conflict
        </button>

        <button
          className={`intro-node left ${completed.includes(5) ? "node-locked" : ""}`}
          disabled={role !== "A" || completed.includes(5)}
          onClick={() => startClass(5)}
        >
          ○ Meaning
        </button>

      </div>

      <div className="reflection-row">

        {completed.includes(1) && (
          <div
            className="reflection-icon"
            onClick={() => navigate(`/module2/bridge/${sessionId}/${role}/1`)}
          >
            ◦
          </div>
        )}

        {completed.includes(2) && (
          <div
            className="reflection-icon"
            onClick={() => navigate(`/module2/bridge/${sessionId}/${role}/2`)}
          >
            ◇
          </div>
        )}

        {completed.includes(3) && (
          <div
            className="reflection-icon"
            onClick={() => navigate(`/module2/bridge/${sessionId}/${role}/3`)}
          >
            △
          </div>
        )}

        {completed.includes(4) && (
          <div
            className="reflection-icon"
            onClick={() => navigate(`/module2/bridge/${sessionId}/${role}/4`)}
          >
            ✦
          </div>
        )}

        {completed.includes(5) && (
          <div
            className="reflection-icon"
            onClick={() => navigate(`/module2/bridge/${sessionId}/${role}/5`)}
          >
            ○
          </div>
        )}

      </div>

      <p className="intro-tagline">
        {role === "A"
          ? "Choose where to begin."
          : "Your partner is choosing where to begin."}
      </p>

    </div>
  );
} 
